import axios from "axios";
export const requestDemo = (payload) => async (dispatch) => {
  try {
    await axios.get(
      `${process.env.REACT_APP_API_URL}/api/demo-request-email/`,
      {
        params: payload,
      }
    );
  } catch (error) {
    console.log(error);
  }
};
export const contactUsEmail = (payload) => async (dispatch) => {
  try {
    await axios.get(`${process.env.REACT_APP_API_URL}/api/contact-us-email/`, {
      params: payload,
    });
  } catch (error) {
    console.log(error);
  }
};
